/**
 * Atlas PM · 项目类型字典 · 接口封装（P4.5）
 *
 * 对接后端 DictController（apps/api/src/modules/dict/dict.controller.ts）：
 *   GET    /system/project-types        列表（含停用，需 dict:manage）
 *   POST   /system/project-types        新建
 *   PATCH  /system/project-types/:id    编辑（code 会被后端忽略，不可改）
 *   DELETE /system/project-types/:id    删除（有引用返回 409 DICT_IN_USE）
 *
 * 后端统一响应 { data }，由 client.ts 解包后直接返回 data。
 */

import { api } from '../../../api/client';

/** 项目类型（与后端 ProjectTypeItem 对齐） */
export interface ProjectTypeItem {
  id: string;
  code: string;
  name: string;
  color: string | null;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
}

/** 新建入参（P6.35：`code` 不传则由服务端自动生成唯一值） */
export interface ProjectTypeCreateInput {
  code?: string;
  name: string;
  color?: string | null;
  sortOrder?: number;
  isActive?: boolean;
}

/** 编辑入参（不含 code —— 后端会忽略） */
export interface ProjectTypeUpdateInput {
  name?: string;
  color?: string | null;
  sortOrder?: number;
  isActive?: boolean;
}

/** 代码规则：只能大写字母、数字、下划线 */
export const CODE_PATTERN = /^[A-Z0-9_]+$/;

export const projectTypeApi = {
  list: () => api.get<ProjectTypeItem[]>('/system/project-types'),

  create: (input: ProjectTypeCreateInput) =>
    api.post<ProjectTypeItem>('/system/project-types', input),

  update: (id: string, input: ProjectTypeUpdateInput) =>
    api.patch<ProjectTypeItem>(`/system/project-types/${id}`, input),

  remove: (id: string) =>
    api.delete<{ ok: boolean; id: string }>(`/system/project-types/${id}`),
};
